import Control from "ol/control/Control";
import WKT from "ol/format/WKT.js";
import { row, rowHeader } from "../util";

export class VectorFeatureControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const div = document.createElement("div");
    div.className = "vector-feature-layer-row";
    const wkt = new WKT();
    super({
      element: div,
      target: options.target,
    });
    const this_ = this;
    const random = Math.floor(Math.random() * 10000);

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.className = "vector-feature-checkbox";
    checkbox.id = "vector-feature-input-" + random;
    checkbox.checked = false;

    checkbox.addEventListener("change", function () {
      this_.set("vectorToggle", checkbox.checked);
    });

    this._checkbox = checkbox;

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    label.className = "vector-feature-text";
    label.innerText = options.layer_name;

    const statusIndicator = document.createElement("span");
    statusIndicator.className = "vector-feature-status";

    const errorMessage = document.createElement("div");
    errorMessage.className = "vector-feature-error-message";

    const attributes = document.createElement("table");
    attributes.className = "ol-selectable vector-feature-attributes-list";

    // Header line: checkbox + label (+ revision icon appended by RevisionControl)
    const header = document.createElement("div");
    header.className = "vector-feature-header";

    div.appendChild(header);
    header.appendChild(checkbox);
    header.appendChild(label);
    header.appendChild(statusIndicator);
    div.appendChild(errorMessage);
    div.append(attributes);

    // Expose so RevisionControl can append its icon into the header
    // and its panel between the header and the attributes table.
    this.headerEl = header;
    this.bodyEl = div;

    this.on("propertychange", () => {
      // roles
      if (this_.get("enabled") == false) {
        div.style.display = "none";
        checkbox.checked = false;
      } else {
        div.style.display = "block";
      }

      // loading / error status
      if (this_.get("loading") === true) {
        statusIndicator.className =
          "vector-feature-status vector-feature-status--loading";
        statusIndicator.title = "Loading…";
        errorMessage.textContent = "";
        errorMessage.style.display = "none";
      } else if (this_.get("loadError") === true) {
        statusIndicator.className =
          "vector-feature-status vector-feature-status--error";
        statusIndicator.title = "Loading failed";
        const reason = this_.get("loadErrorReason");
        errorMessage.textContent = reason
          ? `Failed to load: ${reason}`
          : "Failed to load";
        errorMessage.style.display = "block";
      } else {
        statusIndicator.className = "vector-feature-status";
        statusIndicator.title = "";
        errorMessage.textContent = "";
        errorMessage.style.display = "none";
      }

      // attributes
      if (this_.get("vectorToggle") == false) {
        // unset selected feature if disabled
        this_.set("selectedFeatures", undefined);
      }
      attributes.innerHTML = "";
      const colGroup = document.createElement("colgroup");
      const colLabel = document.createElement("col");
      colLabel.classList.add("label");
      const colValue = document.createElement("col");
      colValue.classList.add("value");
      colGroup.appendChild(colLabel);
      colGroup.appendChild(colValue);
      attributes.appendChild(colGroup);
      const selectedFeatures = this_.get("selectedFeatures");
      if (selectedFeatures !== undefined) {
        attributes.style = "display: table;";

        Array.from(selectedFeatures)
          .sort((f1, f2) => {
            if (f2.get(options.sort_field)) {
              return f2
                .get(options.sort_field)
                .localeCompare(f1.get(options.sort_field));
            }
          })
          .forEach((feature) => {
            if (options.header_field) {
              attributes.append(rowHeader(feature.get(options.header_field)));
            } else {
              attributes.append(rowHeader(feature.getId()));
            }
            if (feature.get("geometry")) {
              const wktInput = document.createElement("input");
              wktInput.disabled = true;
              wktInput.value = wkt.writeGeometry(feature.get("geometry"), {
                dataProjection: "EPSG:4326",
                featureProjection: "EPSG:3857",
              });
              attributes.append(row("wkt", wktInput));
            }
            feature.getKeys().forEach((key) => {
              const value = feature.get(key);
              if (key === "geometry") {
                return;
              }
              if (typeof value === "object") {
                const subAttributes = document.createElement("table");
                subAttributes.className =
                  "ol-selectable vector-feature-subattributes-list";
                for (const [subKey, subValue] of Object.entries(value)) {
                  subAttributes.append(row(subKey, subValue));
                }
                attributes.append(row(key, subAttributes));
              } else {
                attributes.append(row(key, value));
              }
            });
          });
      } else {
        attributes.style = "display: block;";
      }

      // sync checkbox with vectorToggle property
      checkbox.checked = !!this_.get("vectorToggle");

      // active
      if (this_.get("active")) {
        div.classList.add("layer-active");
        div.classList.remove("layer-inactive");
      } else {
        div.classList.remove("layer-active");
        div.classList.add("layer-inactive");
      }
    });
  }

  setToggle(value) {
    this.set("vectorToggle", value);
  }
}
